module.exports = "/_next/static/images/litecoin-843ee67cfea6d08f044467ac07c63ea7.png";